import { Component, OnInit } from '@angular/core';
import {Http, Response} from '@angular/http';

@Component({
  selector: 'app-terms-heading',
  templateUrl: './terms-heading.component.html',
  styleUrls: ['./terms-heading.component.css']
})
export class TermsHeadingComponent implements OnInit {

  

  TermContents;
  constructor(private http: Http) { }

  ngOnInit() { 
    
    //Postal Code Filter APi
    this.http.get("https://logo.sdssoftltd.co.uk/index.php/contents/getContent?title=Terms and Conditions")
    .map((response) => response.json() )
    .subscribe((data) => this.TermContent(data))

  }

  TermContent(data) {this.TermContents = data } 

}
